"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBoxWithFilter = exports.SearchInfoWrapper = exports.Container = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var react_infinite_scroller_1 = __importDefault(require("react-infinite-scroller"));
var styled_components_1 = __importStar(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var matching_1 = require("../../utils/matching");
var Common_1 = require("../Common");
var Icon_1 = require("../Common/Icon");
var Loading_1 = require("../Loading");
var Select_1 = require("../Select");
var ResultsContainer_1 = require("./ResultsContainer");
var SearchBolder_1 = __importDefault(require("./SearchBolder"));
var SharedSearchComponents_1 = require("./SharedSearchComponents");
var smallSize = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: ", ";\n\tright: 10px;\n\ti {\n\t\tfont-size: 13px;\n\t\twidth: 13px;\n\t\theight: 13px;\n\t}\n"], ["\n\theight: ", ";\n\tright: 10px;\n\ti {\n\t\tfont-size: 13px;\n\t\twidth: 13px;\n\t\theight: 13px;\n\t}\n"])), globalVars_module_scss_1.default.heightSmall);
var mediumSize = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: ", ";\n\tright: 12px;\n"], ["\n\theight: ", ";\n\tright: 12px;\n"])), globalVars_module_scss_1.default.heightMedium);
var largeSize = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\theight: ", ";\n\tright: 15px;\n\ti {\n\t\tfont-size: 17px;\n\t\twidth: 17px;\n\t\theight: 17px;\n\t}\n"], ["\n\theight: ", ";\n\tright: 15px;\n\ti {\n\t\tfont-size: 17px;\n\t\twidth: 17px;\n\t\theight: 17px;\n\t}\n"])), globalVars_module_scss_1.default.heightLarge);
exports.Container = styled_components_1.default.div.attrs({
    className: 'tws-searchbox-filter-container',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 100%;\n\tmargin-bottom: 5px;\n\tposition: relative;\n\n\t.tws-searchbox-result-container {\n\t\tright: 5px;\n\t\tz-index: 1;\n\t}\n\n\t.tws-input-text::-ms-clear {\n\t\tdisplay: none;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n"], ["\n\twidth: 100%;\n\tmargin-bottom: 5px;\n\tposition: relative;\n\n\t.tws-searchbox-result-container {\n\t\tright: 5px;\n\t\tz-index: 1;\n\t}\n\n\t.tws-input-text::-ms-clear {\n\t\tdisplay: none;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n"])));
exports.SearchInfoWrapper = styled_components_1.default.div.attrs({
    className: 'tws-searchbox-search-icon-wrapper',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tcolor: ", ";\n\tdisplay: flex;\n\tposition: absolute;\n\ttop: ", ";\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: right;\n\ti {\n\t\tfont-size: 15px;\n\t\tmargin-right: ", ";\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\t", ";\n\t}\n\t", ";\n"], ["\n\tbox-sizing: border-box;\n\tcolor: ", ";\n\tdisplay: flex;\n\tposition: absolute;\n\ttop: ", ";\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: right;\n\ti {\n\t\tfont-size: 15px;\n\t\tmargin-right: ", ";\n\t\twidth: 15px;\n\t\theight: 15px;\n\t\t", ";\n\t}\n\t", ";\n"])), globalVars_module_scss_1.default.secondaryGray2, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, function (props) { return (props.disabled ? 'color: ' + globalVars_module_scss_1.default.gray7 : null); }, function (props) { return (props.size === 'sm' ? smallSize : props.size === 'lg' ? largeSize : mediumSize); });
var SearchBoxWithFilter = /** @class */ (function (_super) {
    __extends(SearchBoxWithFilter, _super);
    function SearchBoxWithFilter(props) {
        var _this = _super.call(this, props) || this;
        // ======== HANDLERS ========== //
        _this.handleOnChange = function (e) {
            _this.searchFor(e.target.value);
        };
        _this.handleOnClear = function () {
            var _a, _b;
            (_b = (_a = _this.props).notifyOnClear) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.setState({
                searchText: '',
                searchHasFocus: false,
                showResults: false,
                showFilterResult: false,
            });
        };
        _this.handleOnSelect = function (option) {
            var _a = _this.props, maxSelected = _a.maxSelected, showSelectedText = _a.showSelectedText, _b = _a.selected, selected = _b === void 0 ? [] : _b;
            if (maxSelected === 1) {
                // Upsert the selection
                _this.props.select([option]);
                // Otherwise if performing a multi-select
            }
            else if (!maxSelected || selected.length < maxSelected) {
                // Append the option to the selection
                _this.props.select(__spreadArray(__spreadArray([], selected, true), [option], false));
            }
            _this.setState({
                searchHasFocus: false,
                showResults: false,
                showFilterResult: !!showSelectedText,
            });
        };
        _this.handleFetchMoreResults = function () {
            var _a = _this.props, getSearchResults = _a.getSearchResults, loading = _a.loading;
            var searchText = _this.state.searchText;
            if (!loading && getSearchResults) {
                getSearchResults(searchText, true);
            }
        };
        _this.handleDocumentClick = function (e) {
            if (_this.props.loading || _this.Disabled) {
                return;
            }
            // FIX: no-find-dom-node issue
            // (see https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md)
            // eslint-disable-next-line react/no-find-dom-node
            var element = ReactDOM.findDOMNode(_this.containerRef);
            if (!element) {
                return;
            }
            var isInFocus = element.contains(e.target);
            _this.setState({ showResults: isInFocus, searchHasFocus: isInFocus });
        };
        _this.state = {
            searchText: '',
            searchHasFocus: false,
            showFilterResult: false,
        };
        _this.containerRef = React.createRef();
        return _this;
    }
    Object.defineProperty(SearchBoxWithFilter.prototype, "CanSearch", {
        get: function () {
            var _a = this.props.minChar, minChar = _a === void 0 ? 0 : _a;
            var searchText = this.state.searchText;
            return searchText.length >= minChar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchBoxWithFilter.prototype, "Disabled", {
        get: function () {
            var _a = this.props, items = _a.items, getSearchResults = _a.getSearchResults;
            return items.length === 0 && !getSearchResults;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchBoxWithFilter.prototype, "SearchResults", {
        get: function () {
            var _a = this.props, filteredItems = _a.filteredItems, items = _a.items, filterOutSelected = _a.filterOutSelected, _b = _a.selected, selected = _b === void 0 ? [] : _b;
            var searchText = this.state.searchText;
            if (!this.CanSearch) {
                // Criteria for displaying/fetching search results has not been met.
                return [];
            }
            // Extract the search results from either the filtered items (if search results are populated externally) or evaluated wrt a buffered in-memory source
            var results = filteredItems !== null && filteredItems !== void 0 ? filteredItems : items.filter(function (option) { return matching_1.MatchingUtil.testObjectMatch(option, searchText, ['name', 'displayText']); });
            var isSelected = new Set(selected.map(function (s) { return s.name; }));
            if (filterOutSelected) {
                return results.filter(function (option) { return !isSelected.has(option.name); });
            }
            return results.map(function (option) { return (__assign(__assign({}, option), { disabled: isSelected.has(option.name) })); });
        },
        enumerable: false,
        configurable: true
    });
    SearchBoxWithFilter.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleDocumentClick);
    };
    SearchBoxWithFilter.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleDocumentClick);
    };
    SearchBoxWithFilter.prototype.componentDidUpdate = function (prevProps) {
        this.onSelectionDidUpdate(prevProps);
        this.onItemsLoaded(prevProps);
    };
    SearchBoxWithFilter.prototype.onSelectionDidUpdate = function (prevProps) {
        var _this = this;
        var prevSelection = prevProps.selected;
        var _a = this.props, maxSelected = _a.maxSelected, selected = _a.selected;
        // Handler that will perform state changes if a selection update is detected
        var onSelChangedDisplay = function (searchText) {
            if (searchText === void 0) { searchText = ''; }
            return _this.setState({
                searchText: searchText,
                showResults: false,
                showFilterResult: false,
            });
        };
        if (maxSelected === 1) {
            var prevSelectedItem = lodash_1.default.first(prevSelection);
            var selectedItem = lodash_1.default.first(selected);
            // If the selection was changed
            if ((prevSelectedItem === null || prevSelectedItem === void 0 ? void 0 : prevSelectedItem.name) !== (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name)) {
                // Set the search text to reflect the selection
                onSelChangedDisplay(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.displayText);
            }
            // If a multi-selection was updated
        }
        else if ((prevSelection === null || prevSelection === void 0 ? void 0 : prevSelection.length) !== (selected === null || selected === void 0 ? void 0 : selected.length)) {
            // Clear the search text to facilitate a re-search.
            onSelChangedDisplay('');
        }
    };
    SearchBoxWithFilter.prototype.onItemsLoaded = function (prevProps) {
        var wasLoading = prevProps.loading;
        var isNowLoaded = !this.props.loading;
        if (wasLoading && isNowLoaded && !this.state.showResults) {
            this.setState({ showResults: true, showFilterResult: true });
        }
    };
    SearchBoxWithFilter.prototype.render = function () {
        var _this = this;
        var _a = this.props, loading = _a.loading, inputSize = _a.inputSize, _b = _a.minChar, minChar = _b === void 0 ? 0 : _b;
        var searchText = this.state.searchText;
        return (React.createElement(exports.Container, { ref: function (ct) { return (_this.containerRef = ct); } },
            React.createElement(SharedSearchComponents_1.InnerSearchContainer, null,
                React.createElement(Common_1.Input, { type: 'text', disabled: this.Disabled, placeholder: this.props.placeholderText, value: searchText, onChange: this.handleOnChange, size: inputSize }),
                React.createElement(ResultsContainer_1.ResultsContainer, { show: !!this.state.showFilterResult && !loading, onClear: this.handleOnClear, resultsCount: this.SearchResults.length }),
                React.createElement(exports.SearchInfoWrapper, { disabled: this.Disabled, size: inputSize }, (function () {
                    if (_this.props.showTips && searchText.length > 0 && searchText.length < minChar) {
                        return "Need at least ".concat(minChar, " characters");
                    }
                    if (loading) {
                        return React.createElement(Loading_1.Loading, { height: '20px', width: '20px' });
                    }
                    if (!_this.state.searchHasFocus && !_this.state.showFilterResult) {
                        return React.createElement(Icon_1.Icon, { className: 'tws-search-icon', name: 'search' });
                    }
                    return null;
                })())),
            this.SearchResultContainer()));
    };
    SearchBoxWithFilter.prototype.SearchResultContainer = function () {
        if (!this.SearchResults.length || !this.state.showResults) {
            return null;
        }
        return (React.createElement(Select_1.DropdownContainer, { optionsContainerWidth: 'inherit' },
            React.createElement(Select_1.OptionsContainer, { applyButton: false }, this.RenderSearchResults())));
    };
    SearchBoxWithFilter.prototype.RenderSearchResults = function () {
        var _this = this;
        var _a = this.props, getSearchResults = _a.getSearchResults, hasMoreResults = _a.hasMoreResults;
        var searchText = this.state.searchText;
        var searchResults = this.SearchResults.map(function (option) { return (React.createElement(Select_1.SelectOption, { key: option.name, item: option, onChange: _this.handleOnSelect },
            React.createElement("div", null,
                React.createElement(SearchBolder_1.default, { text: option.displayText, searchText: searchText })))); });
        // If the search is conducted in a paginated manner
        if (getSearchResults) {
            // Configure a container to continously load and populate result pages as the user scrolls down
            var configureScroll = {
                pageStart: 0,
                loadMore: this.handleFetchMoreResults,
                hasMore: hasMoreResults,
                loader: React.createElement("span", { key: 0 }, "Loading more results..."),
                useWindow: false,
                threshold: 20,
            };
            return React.createElement(react_infinite_scroller_1.default, __assign({}, configureScroll), searchResults);
        }
        return searchResults;
    };
    SearchBoxWithFilter.prototype.searchFor = function (searchText) {
        var _this = this;
        var _a = this.props, getSearchResults = _a.getSearchResults, resetSearchResults = _a.resetSearchResults;
        if (searchText.length === 0 && resetSearchResults) {
            resetSearchResults();
        }
        this.setState({ searchText: searchText }, function () {
            // If the search is evaluated externally
            if (_this.CanSearch && getSearchResults) {
                getSearchResults(searchText);
                // Hide the result window until they become available
                _this.setState({
                    showResults: false,
                    showFilterResult: false,
                });
                return;
            }
            // Search results are evaluated in-memory, so we can immediately show the results.
            _this.setState({
                showResults: _this.CanSearch,
                showFilterResult: _this.CanSearch,
            });
        });
    };
    // Default props
    SearchBoxWithFilter.defaultProps = {
        minChar: 3,
        searchTimeout: 400,
        showTips: true,
    };
    return SearchBoxWithFilter;
}(React.Component));
exports.SearchBoxWithFilter = SearchBoxWithFilter;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
